export default "__VITE_ASSET__Bioz_TAz__"